<div class="container ">
  <h1 class="p-2">Settings</h1>
  <div class="mx-4 md:mx-6 mt-3">

    <app-menu-holder class=" " [optionsHolder]="Profile"></app-menu-holder>
    @if (permissions.ShowUsers) {
      <app-menu-holder class=" " [optionsHolder]="UsersMenu"></app-menu-holder>
    }
    @if (permissions.ShowAudits) {
      <app-menu-holder [optionsHolder]="AuditsMenu"></app-menu-holder>
    }
    @if (permissions.ShowAudits && hasEventPermission) {
      <app-menu-holder [optionsHolder]="EventsMenu"></app-menu-holder>
    }
    @if (permissions.ShowLocations) {
      <app-menu-holder [optionsHolder]="LocationsMenu"></app-menu-holder>
    }
    @if (permissions.ShowTechSupport) {
      <app-menu-holder [optionsHolder]="CustomerSupportMenu"></app-menu-holder>
    }
    @if (permissions.ShowCampaigns && hasCampaignPermission) {
      <app-menu-holder [optionsHolder]="ExternalAuditsMenu"></app-menu-holder>
    }
    <app-manageusers></app-manageusers>
    <!--<app-manageaudits></app-manageaudits>
    <app-manageusers></app-manageusers>
    <app-managelocations></app-managelocations>-->

  </div>
</div>
